import { render, staticRenderFns } from "./order_form_item.vue?vue&type=template&id=fac1f8c6&scoped=true&"
import script from "./order_form_item.vue?vue&type=script&lang=ts&"
export * from "./order_form_item.vue?vue&type=script&lang=ts&"
import style0 from "./order_form_item.vue?vue&type=style&index=0&id=fac1f8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac1f8c6",
  null
  
)

export default component.exports